import { useQuery } from "@apollo/react-hooks";

import { isValidPostCode } from "@ds-developer/frontend";

import { InstructorPrices } from "../types";
import SearchForAddressQuery from "../graph-ql/GetPostcodeInfo.graphql";

const useQueryGetPostcodeInfo = (
  id: string,
  franchiseId?: string,
  postcode?: string,
) =>
  useQuery<{ instructor: InstructorPrices; searchForAddress: any }>(
    SearchForAddressQuery,
    {
      variables: {
        postcode1: postcode,
        postcode2: postcode,
        instructorId: id,
        franchiseId,
      },
      skip: !isValidPostCode(postcode || ""),
    },
  );

export default useQueryGetPostcodeInfo;
